import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MdbModalRef } from 'mdb5-adapted';
import { NgxPaginationModule, PaginationInstance } from 'ngx-pagination';
import { AppUtilityService } from 'src/app/app-utility.service';
import { LmsTableWrapperComponent,LmsModalFrameComponent } from '@lmsShared';
import { BranchService } from '@lmsrestServices';
async function loadXLSX() {
  const XLSX = await import('xlsx');
  return XLSX;
}

@Component({
  selector: 'app-lms-data-report',
  templateUrl: './lms-data-report.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NgxPaginationModule,
    LmsModalFrameComponent,
    LmsTableWrapperComponent
  ],
})
export class LmsDataReportComponent implements AfterViewInit {
  lmsDataReportList: any[] = [];
  reportTitle: string = 'LMS Data Report';
  startDate: string = '';
  endDate: string = '';
  fileName = '';
  data: any;

  @ViewChild('TABLE') table: ElementRef;

  config: PaginationInstance = {
    id: 'lms-data-report-pager',
    itemsPerPage: 15,
    currentPage: 1,
  };


  constructor(
    public global_utility: AppUtilityService,
    private dialogRef: MdbModalRef<LmsDataReportComponent>,
    private branchService: BranchService,
  ) {
  }

  ngAfterViewInit(): void {
    this.branchService.fetchLmsDataReport(this.startDate, this.endDate).subscribe({
      next: (result) => {
        this.lmsDataReportList = result;
        this.global_utility.stopLoading();
      },
      error: (err) => {
        this.global_utility.error(
          `Report load error: ${err.error?.message ?? ''}`,
          'LMS Data Report Error',
        );
        this.global_utility.stopLoading();
      },
    });
  }

  exportToExcel(): void {
    this.fileName = `LmsDataReport_${new Date()
      .toISOString()
      .slice(0, 10)}.xlsx`;
    this.global_utility.startLoading('Exporting data to Excel...');
    loadXLSX()
      .then((XLSX) => {
        const ws = XLSX.utils.table_to_sheet(this.table.nativeElement);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'LMS Data Report');
        XLSX.writeFile(wb, this.fileName);
        this.global_utility.stopLoading();
      })
      .catch((err) => {
        this.global_utility.stopLoading();
        this.global_utility.error('Failed to export Excel: ' + err);
      });
  }

  close() {
    this.dialogRef.close();
  }
}
